module.exports = __webpack_public_path__ + "img/1078.c02dbff7.gif";